@if (data) {
<div class="monthly-summary">

  <!-- KPI Cards -->
  <div class="kpi-cards">
    <div class="kpi-card">
      <div class="kpi-value">{{ formatNumber(data.kpis.total_volume) }}</div>
      <div class="kpi-label">Total Volume (cases)</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-value financial">{{ formatCurrency(data.kpis.total_value) }}</div>
      <div class="kpi-label">Total Value (wholesale $)</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-value">{{ data.kpis.promotions_run }}</div>
      <div class="kpi-label">Promotions Run ({{ data.kpis.buying_group_count }} banner groups)</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-value">{{ formatPercent(data.kpis.avg_compliance_pct) }}</div>
      <div class="kpi-label">Average Compliance</div>
    </div>
  </div>

  <!-- YoY Comparison Bar -->
  <div class="yoy-bar">
    <!-- Volume -->
    <div class="yoy-group">
      <div class="yoy-label">Volume</div>
      <div class="yoy-values">
        <span class="yoy-current">{{ formatNumber(data.yoy.volume_current) }}</span>
        <span class="yoy-separator">vs</span>
        @if (data.yoy.volume_prior !== null) {
          <span class="yoy-prior">{{ formatNumber(data.yoy.volume_prior) }}</span>
        } @else {
          <span class="yoy-prior">N/A</span>
        }
        @if (data.yoy.volume_change_pct !== null) {
          <span
            class="yoy-badge"
            [class.badge-green]="isPositive(data.yoy.volume_change_pct)"
            [class.badge-red]="isNegative(data.yoy.volume_change_pct)">
            {{ formatChange(data.yoy.volume_change_pct) }}
          </span>
        }
      </div>
    </div>

    <!-- Value -->
    <div class="yoy-group">
      <div class="yoy-label">Value</div>
      <div class="yoy-values">
        <span class="yoy-current financial">{{ formatCurrency(data.yoy.value_current) }}</span>
        <span class="yoy-separator">vs</span>
        @if (data.yoy.value_prior !== null) {
          <span class="yoy-prior financial">{{ formatCurrency(data.yoy.value_prior) }}</span>
        } @else {
          <span class="yoy-prior financial">N/A</span>
        }
        @if (data.yoy.value_change_pct !== null) {
          <span
            class="yoy-badge"
            [class.badge-green]="isPositive(data.yoy.value_change_pct)"
            [class.badge-red]="isNegative(data.yoy.value_change_pct)">
            {{ formatChange(data.yoy.value_change_pct) }}
          </span>
        }
      </div>
    </div>

    <!-- Promotions -->
    <div class="yoy-group">
      <div class="yoy-label">Promotions</div>
      <div class="yoy-values">
        <span class="yoy-current">{{ data.yoy.promotions_current }}</span>
        <span class="yoy-separator">vs</span>
        @if (data.yoy.promotions_prior !== null) {
          <span class="yoy-prior">{{ data.yoy.promotions_prior }}</span>
        } @else {
          <span class="yoy-prior">N/A</span>
        }
        @if (data.yoy.promotions_change !== null) {
          <span
            class="yoy-badge"
            [class.badge-green]="isPositive(data.yoy.promotions_change)"
            [class.badge-red]="isNegative(data.yoy.promotions_change)">
            {{ formatPromotionChange(data.yoy.promotions_change) }}
          </span>
        }
      </div>
    </div>
  </div>

  <!-- Export Buttons -->
  <div class="export-buttons">
    <dx-button
      text="Export Excel"
      icon="xlsxfile"
      type="default"
      stylingMode="outlined"
      [disabled]="!data.promotions.length"
      title="{{ !data.promotions.length ? 'No data to export' : '' }}"
      (onClick)="exportExcel()">
    </dx-button>
    <dx-button
      text="Export PDF"
      icon="pdffile"
      type="default"
      stylingMode="outlined"
      [disabled]="!data.promotions.length"
      title="{{ !data.promotions.length ? 'No data to export' : '' }}"
      (onClick)="exportPdf()">
    </dx-button>
  </div>

  <!-- Promotion Performance Table -->
  <dx-data-grid
    class="promotion-grid"
    [dataSource]="data.promotions"
    [showBorders]="false"
    [showRowLines]="true"
    [showColumnLines]="false"
    [columnAutoWidth]="false"
    [allowColumnResizing]="true"
    [width]="'100%'"
    [hoverStateEnabled]="true"
    (onRowClick)="onPromotionRowClick($event)">

    <dxi-column dataField="promotion_name" caption="Promotion" [width]="'auto'"></dxi-column>
    <dxi-column dataField="buying_group" caption="Buying Group" [width]="'auto'"></dxi-column>
    <dxi-column dataField="type" caption="Type" [width]="120" cellTemplate="typeTemplate"></dxi-column>
    <dxi-column dataField="volume" caption="Volume (cases)" [width]="130" alignment="right" cellTemplate="volumeTemplate"></dxi-column>
    <dxi-column dataField="total_value" caption="Total ($)" [width]="140" alignment="right" cellTemplate="valueTemplate"></dxi-column>

    <!-- Type Badge Template -->
    <div *dxTemplate="let cell of 'typeTemplate'">
      <span class="type-badge" [ngClass]="getTypeClass(cell.value)">{{ cell.value }}</span>
    </div>

    <!-- Volume Template -->
    <div *dxTemplate="let cell of 'volumeTemplate'">
      <span class="numeric-cell">{{ formatNumber(cell.value) }}</span>
    </div>

    <!-- Total Value Template -->
    <div *dxTemplate="let cell of 'valueTemplate'">
      <span class="numeric-cell financial">{{ formatCurrency(cell.value) }}</span>
    </div>

  </dx-data-grid>

</div>
}
